import { TrainForm } from "./train-form"

/**
 * IMP-502: closes the page the same way it opened — the free-training field.
 * One gesture, repeated, not a new ask; the contact gesture lives with the
 * partner's support email in the header.
 */
export function FinalCta({
  onTrain,
}: {
  onTrain: (website: string, company: string) => Promise<string | null>
}) {
  return (
    <section className="w-full px-4 pb-16 sm:px-8 sm:pb-24">
      <div className="mx-auto w-full max-w-5xl">
        <div className="border-lp-border relative isolate overflow-hidden rounded-[28px] border px-6 py-16 text-center sm:py-20">
          <div className="lp-mesh lp-mesh-light absolute inset-0 z-0" />
          <div className="lp-mesh-grain absolute inset-0 z-1" />
          <div className="relative z-2 flex flex-col items-center">
            <h2 className="font-lp-serif text-lp-fg max-w-[22ch] text-[clamp(1.625rem,3vw,2.25rem)] leading-[1.08] tracking-[-0.02em] text-balance">
              See it trained on your business
            </h2>
            <p className="text-lp-fg/75 mt-4 max-w-[44ch] text-[15.5px] leading-[1.65]">
              It takes about two minutes.
            </p>
            <div className="mt-8 flex w-full flex-col items-center">
              <TrainForm onTrain={onTrain} tone="on-mesh" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
